import { render, staticRenderFns } from "./modifyUserInfo.vue?vue&type=template&id=38c5500a&scoped=true"
import script from "./modifyUserInfo.vue?vue&type=script&lang=js"
export * from "./modifyUserInfo.vue?vue&type=script&lang=js"
import style0 from "./modifyUserInfo.vue?vue&type=style&index=0&id=38c5500a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5500a",
  null
  
)

export default component.exports